/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarProdutoDto,
  CriarProdutoDto,
  DefinirAtivoProdutoDto,
  ErroResponse,
  PaginaDeProdutosAdminResponse,
  ProdutoAdminResponse,
  ProdutosAdminControllerEnviarImagemBody,
  ProdutosAdminControllerListarParams
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getProdutosAdminControllerListarUrl = (params?: ProdutosAdminControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/produtos-parceiros?${stringifiedParams}` : `/v1/admin/produtos-parceiros`
}

/**
 * @summary Lista os produtos, paginado. Filtra por parceiro.
 */
export const produtosAdminControllerListar = async (params?: ProdutosAdminControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeProdutosAdminResponse> => {

  return httpClient<PaginaDeProdutosAdminResponse>(getProdutosAdminControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProdutosAdminControllerListarQueryKey = (params?: ProdutosAdminControllerListarParams,) => {
    return [
    `/v1/admin/produtos-parceiros`, ...(params ? [params] : [])
    ] as const;
    }


export const getProdutosAdminControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof produtosAdminControllerListar>>, TError = ErroResponse>(params?: ProdutosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProdutosAdminControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof produtosAdminControllerListar>>> = ({ signal }) => produtosAdminControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProdutosAdminControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof produtosAdminControllerListar>>>
export type ProdutosAdminControllerListarQueryError = ErroResponse


export function useProdutosAdminControllerListar<TData = Awaited<ReturnType<typeof produtosAdminControllerListar>>, TError = ErroResponse>(
 params: undefined |  ProdutosAdminControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof produtosAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof produtosAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProdutosAdminControllerListar<TData = Awaited<ReturnType<typeof produtosAdminControllerListar>>, TError = ErroResponse>(
 params?: ProdutosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof produtosAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof produtosAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProdutosAdminControllerListar<TData = Awaited<ReturnType<typeof produtosAdminControllerListar>>, TError = ErroResponse>(
 params?: ProdutosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os produtos, paginado. Filtra por parceiro.
 */

export function useProdutosAdminControllerListar<TData = Awaited<ReturnType<typeof produtosAdminControllerListar>>, TError = ErroResponse>(
 params?: ProdutosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProdutosAdminControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProdutosAdminControllerCriarUrl = () => {




  return `/v1/admin/produtos-parceiros`
}

/**
 * @summary Cadastra um produto no parceiro informado
 */
export const produtosAdminControllerCriar = async (criarProdutoDto: CriarProdutoDto, options?: Parameters<typeof httpClient>[1]): Promise<ProdutoAdminResponse> => {

  return httpClient<ProdutoAdminResponse>(getProdutosAdminControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarProdutoDto)
  }
);}





export const getProdutosAdminControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerCriar>>, TError,{data: CriarProdutoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerCriar>>, TError,{data: CriarProdutoDto}, TContext> => {

const mutationKey = ['produtosAdminControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof produtosAdminControllerCriar>>, {data: CriarProdutoDto}> = (props) => {
          const {data} = props ?? {};

          return  produtosAdminControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProdutosAdminControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof produtosAdminControllerCriar>>>
    export type ProdutosAdminControllerCriarMutationBody = CriarProdutoDto
    export type ProdutosAdminControllerCriarMutationError = ErroResponse

    /**
 * @summary Cadastra um produto no parceiro informado
 */
export const useProdutosAdminControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerCriar>>, TError,{data: CriarProdutoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof produtosAdminControllerCriar>>,
        TError,
        {data: CriarProdutoDto},
        TContext
      > => {
      return useMutation(getProdutosAdminControllerCriarMutationOptions(options), queryClient);
    }
    export const getProdutosAdminControllerObterUrl = (id: string,) => {




  return `/v1/admin/produtos-parceiros/${id}`
}

/**
 * @summary Detalha um produto
 */
export const produtosAdminControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ProdutoAdminResponse> => {

  return httpClient<ProdutoAdminResponse>(getProdutosAdminControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProdutosAdminControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/admin/produtos-parceiros/${id}`
    ] as const;
    }


export const getProdutosAdminControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof produtosAdminControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProdutosAdminControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof produtosAdminControllerObter>>> = ({ signal }) => produtosAdminControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProdutosAdminControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof produtosAdminControllerObter>>>
export type ProdutosAdminControllerObterQueryError = ErroResponse


export function useProdutosAdminControllerObter<TData = Awaited<ReturnType<typeof produtosAdminControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof produtosAdminControllerObter>>,
          TError,
          Awaited<ReturnType<typeof produtosAdminControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProdutosAdminControllerObter<TData = Awaited<ReturnType<typeof produtosAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof produtosAdminControllerObter>>,
          TError,
          Awaited<ReturnType<typeof produtosAdminControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProdutosAdminControllerObter<TData = Awaited<ReturnType<typeof produtosAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um produto
 */

export function useProdutosAdminControllerObter<TData = Awaited<ReturnType<typeof produtosAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof produtosAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProdutosAdminControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProdutosAdminControllerAtualizarUrl = (id: string,) => {




  return `/v1/admin/produtos-parceiros/${id}`
}

/**
 * @summary Edita. O parceiro dono não muda — ver o DTO.
 */
export const produtosAdminControllerAtualizar = async (id: string,
    atualizarProdutoDto: AtualizarProdutoDto, options?: Parameters<typeof httpClient>[1]): Promise<ProdutoAdminResponse> => {

  return httpClient<ProdutoAdminResponse>(getProdutosAdminControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarProdutoDto)
  }
);}





export const getProdutosAdminControllerAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerAtualizar>>, TError,{id: string;data: AtualizarProdutoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerAtualizar>>, TError,{id: string;data: AtualizarProdutoDto}, TContext> => {

const mutationKey = ['produtosAdminControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof produtosAdminControllerAtualizar>>, {id: string;data: AtualizarProdutoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  produtosAdminControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProdutosAdminControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof produtosAdminControllerAtualizar>>>
    export type ProdutosAdminControllerAtualizarMutationBody = AtualizarProdutoDto
    export type ProdutosAdminControllerAtualizarMutationError = unknown

    /**
 * @summary Edita. O parceiro dono não muda — ver o DTO.
 */
export const useProdutosAdminControllerAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerAtualizar>>, TError,{id: string;data: AtualizarProdutoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof produtosAdminControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarProdutoDto},
        TContext
      > => {
      return useMutation(getProdutosAdminControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getProdutosAdminControllerDefinirAtivoUrl = (id: string,) => {




  return `/v1/admin/produtos-parceiros/${id}/ativo`
}

/**
 * @summary Ativa ou desativa. Substitui o delete.
 */
export const produtosAdminControllerDefinirAtivo = async (id: string,
    definirAtivoProdutoDto: DefinirAtivoProdutoDto, options?: Parameters<typeof httpClient>[1]): Promise<ProdutoAdminResponse> => {

  return httpClient<ProdutoAdminResponse>(getProdutosAdminControllerDefinirAtivoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirAtivoProdutoDto)
  }
);}





export const getProdutosAdminControllerDefinirAtivoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoProdutoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoProdutoDto}, TContext> => {

const mutationKey = ['produtosAdminControllerDefinirAtivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof produtosAdminControllerDefinirAtivo>>, {id: string;data: DefinirAtivoProdutoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  produtosAdminControllerDefinirAtivo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProdutosAdminControllerDefinirAtivoMutationResult = NonNullable<Awaited<ReturnType<typeof produtosAdminControllerDefinirAtivo>>>
    export type ProdutosAdminControllerDefinirAtivoMutationBody = DefinirAtivoProdutoDto
    export type ProdutosAdminControllerDefinirAtivoMutationError = unknown

    /**
 * @summary Ativa ou desativa. Substitui o delete.
 */
export const useProdutosAdminControllerDefinirAtivo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoProdutoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof produtosAdminControllerDefinirAtivo>>,
        TError,
        {id: string;data: DefinirAtivoProdutoDto},
        TContext
      > => {
      return useMutation(getProdutosAdminControllerDefinirAtivoMutationOptions(options), queryClient);
    }
    export const getProdutosAdminControllerEnviarImagemUrl = (id: string,) => {




  return `/v1/admin/produtos-parceiros/${id}/imagem`
}

/**
 * @summary Envia a imagem. Exige proporção 1:1 (ex.: 800×800).
 */
export const produtosAdminControllerEnviarImagem = async (id: string,
    produtosAdminControllerEnviarImagemBody: ProdutosAdminControllerEnviarImagemBody, options?: Parameters<typeof httpClient>[1]): Promise<ProdutoAdminResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, produtosAdminControllerEnviarImagemBody.arquivo);

  return httpClient<ProdutoAdminResponse>(getProdutosAdminControllerEnviarImagemUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getProdutosAdminControllerEnviarImagemMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerEnviarImagem>>, TError,{id: string;data: ProdutosAdminControllerEnviarImagemBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerEnviarImagem>>, TError,{id: string;data: ProdutosAdminControllerEnviarImagemBody}, TContext> => {

const mutationKey = ['produtosAdminControllerEnviarImagem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof produtosAdminControllerEnviarImagem>>, {id: string;data: ProdutosAdminControllerEnviarImagemBody}> = (props) => {
          const {id,data} = props ?? {};

          return  produtosAdminControllerEnviarImagem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProdutosAdminControllerEnviarImagemMutationResult = NonNullable<Awaited<ReturnType<typeof produtosAdminControllerEnviarImagem>>>
    export type ProdutosAdminControllerEnviarImagemMutationBody = ProdutosAdminControllerEnviarImagemBody
    export type ProdutosAdminControllerEnviarImagemMutationError = ErroResponse

    /**
 * @summary Envia a imagem. Exige proporção 1:1 (ex.: 800×800).
 */
export const useProdutosAdminControllerEnviarImagem = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof produtosAdminControllerEnviarImagem>>, TError,{id: string;data: ProdutosAdminControllerEnviarImagemBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof produtosAdminControllerEnviarImagem>>,
        TError,
        {id: string;data: ProdutosAdminControllerEnviarImagemBody},
        TContext
      > => {
      return useMutation(getProdutosAdminControllerEnviarImagemMutationOptions(options), queryClient);
    }
